import * as React from 'react';
import { Input, Typography } from 'antd';
import './LabelledInput.scss';

type UiMode = 'horizontal' | 'vertical';

export interface LabelledInputProps {
  label: string;
  helperText?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  mode: UiMode;
  disable?: boolean;
  onKeyDown?: () => void;
  marginLeft?: boolean;
  marginTop?: boolean;
  marginRight?: boolean;
  marginBottom?: boolean;
}

function getContainerClassName(mode: UiMode): string {
  switch (mode) {
    case 'horizontal':
      return 'input-row-container';
    case 'vertical':
      return 'input-column-container';
  }
}

function getLabelClassName(mode: UiMode): string {
  switch (mode) {
    case 'horizontal':
      return 'input-label-row';
    case 'vertical':
      return 'input-label-column';
  }
}

const LabelledInput: React.FunctionComponent<LabelledInputProps> = (
  props: LabelledInputProps
) => {
  const { label, helperText, value, onChange, mode, onKeyDown } = props;
  const marginStyle = {
    marginLeft: props.marginLeft ? '8px' : '0px',
    marginTop: props.marginTop ? '8px' : '0px',
    marginRight: props.marginRight ? '8px' : '0px',
    marginBottom: props.marginBottom ? '8px' : '0px',
  };

  return (
    <div className={getContainerClassName(mode)} style={marginStyle}>
      <Typography.Text className={getLabelClassName(mode)}>
        {helperText}
      </Typography.Text>
      <Input
        placeholder={label}
        disabled={props.disable}
        value={value || ''}
        onChange={onChange}
        style={{ flex: 1 }}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default LabelledInput;
